import FormValidator from "../components/FormValidator";
import Page from "./Page";
import tingle from 'tingle.js/dist/tingle.min.js';

export default new class Home extends Page {
    constructor() {
        super();
    }

    index() {
        // Formulaire d'inscription
        var modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            cssClass: ['custom-class-1', 'custom-class-2'],
            onOpen: function() {
                console.log('modal open');
            },
            onClose: function() {
                console.log('modal closed');
            }
        });
        if(document.getElementById('formInscription')) {
            modal.setContent(document.getElementById('formInscription').dataset.html);
        }

        const formInscriptionSend = async () => {
            const form = document.querySelector('#inscriptionForm');
            const url = form.getAttribute('action') ?? window.location.href;
            const data = new FormData(form);

            await fetch(url, {
                method: 'POST',
                body: data,
                redirect: 'follow'
            })
            .then(response => response.json())
            .then(result => {
                if(result.status === 200) {
                    document.location = 'https://www.thegenzshift.com/get-sample/';
                    form.reset();
                } else if (result.status === 400) {
                    form.querySelector('.form__message .error-1').style.display = 'inline-block';
                } else if (result.status === 429) {
                    form.querySelector('.form__message .error-3').style.display = 'inline-block';
                } else if (result.status === 427) {
                    form.querySelector('.form__message .error-4').style.display = 'inline-block';
                } else if (result.status === 431) {
                    form.querySelector('.form__message .error-5').style.display = 'inline-block';
                } else {
                    form.querySelector('.form__message .error-2').style.display = 'inline-block';
                }
            })
            .catch(error => console.error('error', error));
        };

        // Validation du formulaire
        const fieldInscriptions = [
            ['text', '#inscription_firstname', '#inscription_firstname'],
            ['text', '#inscription_lastname', '#inscription_lastname'],
            ['text', '#inscription_company', '#inscription_company'],
            ['email', '#inscription_email', '#inscription_email'],
        ];

        new FormValidator('#inscriptionForm', fieldInscriptions, {
            afterValidationSuccess : formInscriptionSend,
        });
        
        // open modal
        document.querySelectorAll('a[href="#"]').forEach(link => {
            link.addEventListener('click', () => {
                modal.open();
            })
        })
        
        // close modal
        // modal.close();
    }
}